import { SurveyQuestion } from "../../../types";

export default function getControlProps(
  question: SurveyQuestion,
  error: string
) {
  const props: any = {
    id: `velaro-survey-question-${question.QuestionID}`
  };

  if (question.Required) {
    props["aria-required"] = true;
  }

  if (error) {
    props["aria-invalid"] = true;
    props["aria-describedby"] = `${question.QuestionID}-err-msg`;
  }

  return props;
}
